import { Clock, Info } from "lucide-react";
import { BOOKSY_URL, SERVICES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Services = () => (
    <section id="servicios" data-testid="services-section" className="scroll-mt-20 bg-white py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold">
                    01 · Precios y tratamientos
                </p>
                <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
                    Nuestros Servicios
                </h2>
                <p className="mt-4 max-w-2xl text-base text-gray-600">
                    Reserva online en un minuto. Cada servicio incluye valoración previa de tu
                    vehículo para un resultado impecable.
                </p>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
                {SERVICES.map((service, index) => (
                    <Reveal key={service.id} delay={(index % 3) * 0.08} className="h-full">
                        <article
                            data-testid={`service-card-${service.id}`}
                            className="flex h-full flex-col rounded-md border border-ink/10 bg-white p-7 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-xl hover:shadow-black/10"
                        >
                            <h3 className="font-display text-lg font-bold text-ink">
                                {service.name}
                            </h3>
                            <div className="mt-4 flex items-end justify-between gap-3">
                                <span className="font-display text-3xl font-extrabold text-gold">
                                    {service.price}
                                </span>
                                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-gray-500">
                                    <Clock className="h-4 w-4" />
                                    {service.duration}
                                </span>
                            </div>
                            {service.note && (
                                <p className="mt-4 text-xs italic leading-relaxed text-gray-500">
                                    {service.note}
                                </p>
                            )}
                            <a
                                href={BOOKSY_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`service-book-${service.id}`}
                                className="mt-auto inline-flex items-center justify-center rounded-sm bg-ink px-5 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-gold hover:text-ink"
                            >
                                Reservar
                            </a>
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal className="mt-12">
                <div
                    data-testid="services-price-note"
                    className="mx-auto flex max-w-2xl items-center justify-center gap-3 rounded-sm border border-gold/40 bg-gold/5 px-6 py-4 text-center"
                >
                    <Info className="h-5 w-5 shrink-0 text-gold" />
                    <p className="text-sm font-semibold text-ink/70">
                        El precio definitivo se confirma el día de la cita, tras valorar el estado
                        del vehículo
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
